// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__BhUaX","content":"PrivacyPolicyPage_content__GaLrv"};